export function isTrelloAddon(location) {
  const params = location && location.query || {};
  return (
    params.app === 'trello' &&
    !params['configure'] &&
    (
      params['no-dashboard'] === 'true' ||
      (
        params['utm_source'] === 'addon' &&
        params['utm_medium'] === 'trello' &&
        params['utm_campaign'] === 'marketplace'
      )
    )
  )
}

export function isJiraPlugin(location) {
  const params = location && location.query || {};
  return (
    params.app === 'jira' &&
    !params['configure'] &&
    params['no-dashboard'] === 'true' &&
    !!params['boardId'] &&
    !!params['host']
  )
}

export function isAkbAddon(location) {
  const params = location && location.query || {};
  return (
    params.app === 'akb' &&
    !!params['akbBoardId'] &&
    !!params['aid'] &&
    !params['configure'] &&
    (
      params['no-dashboard'] === 'true' ||
      (
        params['utm_source'] === 'addon' &&
        params['utm_medium'] === 'jira' &&
        params['utm_campaign'] === 'marketplace'
      )
    )
  )
}
